import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(user.is_admin ? '/admin' : '/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4"
         style={{ backgroundImage: 'radial-gradient(ellipse at 50% 50%, rgba(249,115,22,0.08) 0%, transparent 70%)' }}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src="/icon-192.png" alt="OrcFácil" className="w-32 h-32 rounded-2xl object-cover mb-4 mx-auto block shadow-[0_0_40px_rgba(249,115,22,0.35)]" />
          <h1 className="font-heading text-3xl font-bold text-white">OrcFácil</h1>
          <p className="text-zinc-500 mt-1 text-sm">Serviços e Agendamento de Atendimento</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 space-y-5">
          <h2 className="font-heading text-xl font-semibold text-white">Entrar</h2>

          <div>
            <label className="field-label">E-mail</label>
            <input
              data-testid="email-input"
              type="email"
              required
              className="field-input"
              placeholder="seu@email.com"
              value={form.email}
              onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
            />
          </div>

          <div>
            <label className="field-label">Senha</label>
            <div className="relative">
              <input
                data-testid="password-input"
                type={showPass ? 'text' : 'password'}
                required
                className="field-input pr-10"
                placeholder="••••••••"
                value={form.password}
                onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              />
              <button type="button" onClick={() => setShowPass(p => !p)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300">
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <div className="flex justify-end">
            <Link to="/forgot-password" className="text-xs text-orange-400 hover:text-orange-300">
              Esqueci minha senha
            </Link>
          </div>

          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-400 disabled:opacity-50 text-white font-semibold py-2.5 px-4 rounded-xl transition-colors duration-150"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>

          <p className="text-center text-sm text-zinc-500">
            Não tem conta?{' '}
            <Link to="/register" className="text-orange-400 hover:text-orange-300 font-medium">
              Criar conta gratuita
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
